import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { revertAll, RootState } from '../../store';
import { NWClient } from '../../client/NWClient';
import { DocumentTemplatePlaceholder } from '../../../api/Api';

type PlaceholderData = {
  data: { field: string; value: string; placeholder: string };
  //[contractGenerated ? 'document_contract' : 'document_upload']: documentUploadId,
  document_upload: number;
  document_upload_html?: number;
  user: number;
};

export const updatePlaceholder = createAsyncThunk(
  'templatePlaceholders/updatePlaceholder',
  async ({ data, id }: { data: PlaceholderData; id: number }) => {
    const result = await NWClient.put(`document-template-placeholder`, id, data, true);
    return result as DocumentTemplatePlaceholder;
  }
);

interface TemplatePlaceholdersState {
  templateArray: {
    id?: number;
    data: { field: string; value: string; placeholder: string };
  }[];
}

const initialState: TemplatePlaceholdersState = { templateArray: [] };

const templatePlaceholdersSlice = createSlice({
  initialState,
  name: 'templatePlaceholders',
  reducers: {
    setTemplatePlaceholders: (state, action) => {
      state.templateArray = action.payload;
    },
    resetTemplatePlaceholders: (state) => {
      state.templateArray = [];
    },
  },
  extraReducers(builder) {
    builder
      .addCase(updatePlaceholder.fulfilled, (state, action) => {
        // @ts-expect-error: there can be error
        state.templateArray.find((el) => el.id === action.payload.id)!.data = action.payload.data;
      })
      .addCase(revertAll, () => initialState);
  },
});

export default templatePlaceholdersSlice.reducer;

export const { setTemplatePlaceholders, resetTemplatePlaceholders } =
  templatePlaceholdersSlice.actions;
export const selectTemplatePlaceholders = (state: RootState) =>
  state.templatePlaceholders.templateArray;
